import React from 'react';
import {ScreenDesignerConsumer} from "../../ContextComponents/ScreenDesignerContext";

const ScreenDesignerHoc = (Wrapped) => {
    return (props) => {
        return (
            <ScreenDesignerConsumer>
                {
                    (screenProps) => {
                        return (
                            <Wrapped {...props} {...screenProps}/>
                        )
                    }
                }
            </ScreenDesignerConsumer>
        )
    }
};
export default ScreenDesignerHoc;